const ContactTypes = {
    Chat: 'chat',
    Meetings: 'meetings',
} as const;

export default ContactTypes;
